import { HolidayTripsQueryType } from 'api/holiday-trips-list';
import { autoinject, computedFrom, newInstance } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { log } from 'framework/script_utilities/dev-decorators';
import { TaskCounter } from 'framework/script_utilities/task-executor';
import { IdentityService } from 'services/identity-service';
import { requireServices } from 'support/activation';
import { HOME_ROUTE } from 'support/settings';

@autoinject
export class HolidayTripsListScreen {
  router: Router;

  constructor(private identity: IdentityService, @newInstance() private taskCounter: TaskCounter) { }

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'current' },
      { route: 'current', viewPorts: { main: { moduleId: 'screens/holiday_trips/lists/trips-common' }, toolbar: { moduleId: 'components/toolbars/clear-filters-toolbar' } }, name: 'trips-current', activationStrategy: 'replace', title: 'My Current', nav: true, settings: { queryType: HolidayTripsQueryType.Current } },
      { route: 'past', viewPorts: { main: { moduleId: 'screens/holiday_trips/lists/trips-common' }, toolbar: { moduleId: 'components/toolbars/clear-filters-toolbar' } }, name: 'trips-past', activationStrategy: 'replace', title: 'My Past', nav: true, settings: { queryType: HolidayTripsQueryType.Past } },
      { route: 'all', viewPorts: { main: { moduleId: 'screens/holiday_trips/lists/trips-common' }, toolbar: { moduleId: 'components/toolbars/clear-filters-toolbar' } }, name: 'trips-all', activationStrategy: 'replace', title: 'For Admin', nav: true, settings: { queryType: HolidayTripsQueryType.All } }
    ]);

    this.router = router;
  }

  async canActivate() {
    await requireServices(this.identity);
  }

  @log('debug')
  activate() {
    this.applyPermissions();
  }

  private applyPermissions() {
    this.router.navigation.find(i => i.config.name === 'trips-all').settings['hidden'] = !this.identity.roles.isAdmin;
  }

  @computedFrom('taskCounter.runningCount')
  get reloading() {
    return this.taskCounter.runningCount > 0;
  }

  createTrip() {
    this.router.navigate(`#/${HOME_ROUTE}/holidays/new`);
  }
}
